import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../styles'

export type RoundedButtonProps = {
  disabled?: boolean
  fitToParent?: boolean
  icon?: React.ReactNode
  inverted?: boolean
  kind?: 'primary' | 'secondary'
} & React.ButtonHTMLAttributes<HTMLButtonElement>

function RoundedButtonComponent({
  children,
  disabled = false,
  fitToParent = false,
  icon,
  inverted = false,
  kind = 'primary',
  ...buttonProps
}: RoundedButtonProps): React.ReactElement {
  return (
    <S.button.RoundedButton
      fitToParent={fitToParent}
      disabled={disabled}
      inverted={inverted}
      kind={kind}
      {...buttonProps}
    >
      {icon && icon}
      {children}
    </S.button.RoundedButton>
  )
}

export const RoundedButton = styled(RoundedButtonComponent)``
